import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c746470"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "emergency-outhr-details-modal"
}
const _hoisted_2 = { class: "emergency-outhr-details-modal__item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "emergency-outhr-details-modal__title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Issue Name")
], -1))
const _hoisted_4 = { class: "emergency-outhr-details-modal__item" }
const _hoisted_5 = { class: "emergency-outhr-details-modal__title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Project notes", -1))
const _hoisted_7 = { class: "emergency-outhr-details-modal__text" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "emergency-outhr-details-modal__item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "emergency-outhr-details-modal__title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Select Specialisms")
], -1))
const _hoisted_11 = { class: "emergency-outhr-details-modal__specialisms" }
const _hoisted_12 = { class: "emergency-outhr-details-modal__specialisms-inner" }
const _hoisted_13 = { class: "emergency-outhr-details-modal__specialisms-icon" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  class: "more-items-tag"
}
const _hoisted_16 = { class: "emergency-outhr-details-modal__item" }
const _hoisted_17 = { class: "emergency-outhr-details-modal__title" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Date and time", -1))
const _hoisted_19 = { class: "emergency-outhr-details-modal__date-time" }
const _hoisted_20 = { class: "emergency-outhr-details-modal__date-time-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "emergency-outhr-details-modal__date-time-item-left" }, " Weekdays ", -1))
const _hoisted_22 = { class: "emergency-outhr-details-modal__date-time-item-right" }
const _hoisted_23 = { class: "emergency-outhr-details-modal__date-time-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "emergency-outhr-details-modal__date-time-item-left" }, " Time Range ", -1))
const _hoisted_25 = { class: "emerg return daysency-outhr-details-modal__date-time-item-right" }
const _hoisted_26 = { class: "emergency-outhr-details-modal__item" }
const _hoisted_27 = { class: "emergency-outhr-details-modal__title" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "SLA Time (Manual Intervention)", -1))
const _hoisted_29 = { class: "emergency-outhr-details-modal__text" }
const _hoisted_30 = { class: "emergency-outhr-details-modal__item" }
const _hoisted_31 = { class: "emergency-outhr-details-modal__title" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Preferred Contractor", -1))
const _hoisted_33 = { class: "emergency-outhr-details-modal__contractor" }
const _hoisted_34 = { class: "emergency-outhr-details-modal__contractor-inner" }
const _hoisted_35 = { class: "emergency-outhr-details-modal__contractor-image" }
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  key: 0,
  class: "more-items-tag"
}
const _hoisted_38 = { class: "emergency-outhr-details-modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, {
    class: "tw-max-w-[620px]",
    headerTitle: "Out of Hours",
    onOnClose: $setup.onCloseDetailsModal
  }, {
    body: _withCtx(() => [
      ($props.selectedEOHEventDetails)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_v_text_field, {
                class: "custom_input",
                variant: "outlined",
                value: $props.selectedEOHEventDetails.title,
                disabled: true
              }, null, 8, ["value"])
            ]),
            _createVNode(_component_v_divider, {
              color: "#C5D2F2",
              class: "border-opacity-100"
            }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_v_icon, {
                  color: "#0C0F4A",
                  icon: "mdi-information-variant-circle-outline"
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", {
                  innerHTML: $props.selectedEOHEventDetails.description
                }, null, 8, _hoisted_8)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.selectedEOHEventDetails.EOHSpecialism, (specialism, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (index < 3)
                        ? (_openBlock(), _createElementBlock("div", {
                            class: "emergency-outhr-details-modal__specialisms-item",
                            key: specialism.id
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("img", {
                                src: 
                        require('@/assets/category-icons/' +
                          specialism.subCategories.category.iconName +
                          '.svg')
                      
                              }, null, 8, _hoisted_14)
                            ]),
                            _createElementVNode("p", null, _toDisplayString(specialism.subCategories.label), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]),
                ($props.selectedEOHEventDetails.EOHSpecialism.length >= 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($props.selectedEOHEventDetails.EOHSpecialism.length - 3) + "+ ", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_v_icon, {
                  color: "#0C0F4A",
                  icon: "mdi-information-variant-circle-outline"
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, _toDisplayString($setup.showWeekDays()), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, _toDisplayString($props.selectedEOHEventDetails.fromTimeAndDay.time) + " " + _toDisplayString($props.selectedEOHEventDetails.fromTimeAndDay.day) + " - " + _toDisplayString($props.selectedEOHEventDetails.toTimeAndDay.time) + " " + _toDisplayString($props.selectedEOHEventDetails.toTimeAndDay.day), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_v_icon, {
                  color: "#0C0F4A",
                  icon: "mdi-information-variant-circle-outline"
                })
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("p", null, _toDisplayString($setup.slaTime.hours) + " HH : " + _toDisplayString($setup.slaTime.minutes) + " MM", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_v_icon, {
                  color: "#0C0F4A",
                  icon: "mdi-information-variant-circle-outline"
                })
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.preferredContractor, (contractor, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (index < 3)
                        ? (_openBlock(), _createElementBlock("div", {
                            class: "emergency-outhr-details-modal__contractor-item",
                            key: contractor.id
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("img", {
                                src: contractor.userWorkstation.publicURL
                              }, null, 8, _hoisted_36)
                            ]),
                            _createElementVNode("p", null, _toDisplayString(contractor.userWorkstation.name), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]),
                ($setup.preferredContractor.length >= 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString($setup.preferredContractor.length - 3) + "+ ", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_v_btn, {
          class: "button button-purple-border",
          onClick: $setup.onClickBackButton
        }, {
          default: _withCtx(() => [
            _createTextVNode("Back")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_btn, {
          class: "button button-orange",
          onClick: $setup.onClickNextButton
        }, {
          default: _withCtx(() => [
            _createTextVNode("Next")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}